import { render, staticRenderFns } from "./PermissionsTable.vue?vue&type=template&id=3f51dcf6&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./PermissionsTable.vue?vue&type=script&lang=js&"
export * from "./PermissionsTable.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VDataTable,VSwitch})


/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f51dcf6')) {
      api.createRecord('3f51dcf6', component.options)
    } else {
      api.reload('3f51dcf6', component.options)
    }
    module.hot.accept("./PermissionsTable.vue?vue&type=template&id=3f51dcf6&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&", function () {
      api.rerender('3f51dcf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/permissions/PermissionsTable.vue"
export default component.exports